<template>
  <div class="bg-card text-card-foreground flex flex-col gap-6 rounded-xl border border-border shadow-sm">
    <div v-if="$slots.header" class="px-6 pt-6">
      <slot name="header"></slot>
    </div>
    
    <div class="px-6" :class="{ 'pb-6': !$slots.footer }">
      <slot></slot>
    </div>
    
    <div v-if="$slots.footer" class="px-6 pb-6 border-t border-border pt-6">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ThemedCard'
}
</script>
